import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Button from '../Button';

const getTimeWithUsCopy = (years, months) => {
  if (years > 0) {
    return trans('listing.landlord_info.years_with_us', {
      years
    });
  }

  if (months > 0) {
    return trans('listing.landlord_info.months_with_us', {
      months
    });
  }

  return null;
};

const LLInfo = ({
  landlordInformation = null,
  loading = false,
  onClick = () => {},
  children = null
}) => {
  if (!landlordInformation || loading) {
    return null;
  }

  const { type, yearsWithUs, monthsWithUs } = landlordInformation;
  const timeWithUsCopy = getTimeWithUsCopy(yearsWithUs, monthsWithUs);

  return (
    <>
      {trans(type)} ·{' '}
      {timeWithUsCopy && (
        <>
          <span
            dangerouslySetInnerHTML={{
              __html: timeWithUsCopy
            }}
          />{' '}
        </>
      )}
      <Button color="link" onClick={onClick}>
        {trans('landlord_information.more')}
      </Button>
      {children}
    </>
  );
};

LLInfo.propTypes = {
  landlordInformation: PropTypes.shape({
    type: PropTypes.string,
    yearsWithUs: PropTypes.number,
    monthsWithUs: PropTypes.number
  }),
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default LLInfo;
